module.exports = __webpack_public_path__ + "img/ca_zampa_animale_4.b2dad77b.jpg";